import { render, staticRenderFns } from "./CampaignReviewDialog.vue?vue&type=template&id=47dd4768"
import script from "./CampaignReviewDialog.vue?vue&type=script&lang=ts"
export * from "./CampaignReviewDialog.vue?vue&type=script&lang=ts"
import style0 from "./CampaignReviewDialog.vue?vue&type=style&index=0&id=47dd4768&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports